import jwtDecode from 'jwt-decode';
import { AuthModel } from '~models/auth';

export function deserializeAccessToken(token: string): AuthModel.User {
  const decodedToken = jwtDecode<AuthModel.TokenData>(token);

  return {
    ...decodedToken,
    accessToken: token,
  };
}
